import dayjs from 'dayjs';
import 'dayjs/locale/nb';
dayjs.locale('nb');

export const getTime = (date) => dayjs(date).format('HH.mm');
export const parseDateString = (date) => dayjs(date);
const dayString = (date) => dayjs(date).format('HH.mm D.M.YYYY');
export const today = () => dayjs().format('YYYY-MM-DD');
const formatDay = (date) => dayjs(date).format('YYYY-MM-DD');
export const yesterday = (date) =>
  parseDateString(date).subtract(1, 'day').format('YYYY-MM-DD');

export const dateISO = (date) => dayjs(date).toISOString();

export const getDateText = (date) => {
  if (!date) {
    date = today();
  }
  if (formatDay(date) === today()) {
    return getTime(date);
  } else if (formatDay(date) === yesterday(today())) {
    return `I går ${getTime(date)}`;
  } else {
    return dayString(date);
  }
};
